import React from 'react';

import type { IStarState } from '../../../models';

export const DashedStar = ({ dataTestId, key, onClick, onMouseEnter }: IStarState) => (
    <svg
        key={key}
        data-test-id={dataTestId}
        fill="none"
        height="32"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.7513 4.67326C15.1832 3.51813 16.8171 3.51813 17.2491 4.67326L19.641 11.0702C19.8284 11.5713 20.2972 11.9119 20.8317 11.9353L27.6547 12.2334C28.8868 12.2872 29.3917 13.8412 28.4265 14.6089L23.0819 18.8606C22.6632 19.1936 22.4841 19.7447 22.6271 20.2603L24.4519 26.8415C24.7815 28.0299 23.4596 28.9903 22.4312 28.3096L16.7361 24.5404C16.2899 24.2451 15.7105 24.2451 15.2643 24.5404L9.56914 28.3096C8.54073 28.9903 7.21888 28.0299 7.54841 26.8415L9.37328 20.2603C9.51624 19.7447 9.33718 19.1936 8.91849 18.8606L3.57381 14.6089C2.60869 13.8412 3.11359 12.2872 4.34566 12.2334L11.1687 11.9353C11.7032 11.9119 12.1719 11.5713 12.3593 11.0702L14.7513 4.67326Z"
            stroke="#F15045"
        />
        <path
            clipRule="evenodd"
            d="M3.64648 14.6465L6.64648 11.6465L7.35359 12.3536L4.35359 15.3536L3.64648 14.6465Z"
            fill="#F15045"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M5.64648 16.6465L10.68 11.613L12 11.5L12.6144 9.67853L17.6465 4.64645L17.7072 5.30722V6L6.35359 17.3536L5.64648 16.6465Z"
            fill="#F15045"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M8 18.5V18.2929L18.6465 7.64645L19 8.5L18.8959 8.81124L8.70715 19H8.5L8 18.5Z"
            fill="#F15045"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M8.64648 21.6465L19.6465 10.6465L20.3536 11.3536L8.70715 23L8.64648 21.6465Z"
            fill="#F15045"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M7.29248 27L22.6463 11.6465L23.3534 12.3536L7.49951 28.2072L7.29248 27Z"
            fill="#F15045"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M12 26.2929L26.293 12L27.3536 12.3536L13.3536 26.3536L12 26.2929Z"
            fill="#F15045"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M17.6465 24.6465L22.6465 19.6465L23 20.7072L18.3536 25.3536L17.6465 24.6465Z"
            fill="#F15045"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M19.6465 26.6465L23.6465 22.6465L23.7072 24L20.3536 27.3536L19.6465 26.6465Z"
            fill="#F15045"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M22 28.2929L24.5 25.793L24.7072 27L23 28.7072L22 28.2929Z"
            fill="#F15045"
            fillRule="evenodd"
        />
    </svg>
);
